<template>
  <dx-modal
    id="update-cbhpm-modal"
    :title="newItem ? 'Cadastrar operadora' : 'Gerenciamento de operadoras e agrupadores'"
    :size="newItem ? 'sm' : 'md'"
    :value="true"
    @input="close"
  >
    <div class="loading loading-lg" v-if="loading" />
    <template v-else>
      <button class="btn btn-icon btn-icon-left btn-primary mb-2"
              v-if="!newItem"
              @click="addNew">
        <fa-icon :icon="['fal', 'plus']"/>Nova operadora / agrupador
      </button>
      <div v-if="newItem">
        <div class="columns">
          <div class="column col-12 form-group"
               :class="{'has-error': $v.form.name.$error}">
            <label class="form-label">Nome da operadora</label>
            <input type="text"
                   class="form-input"
                   v-model="form.name"
                   @blur="$v.form.name.$touch()"
                   placeholder="Nome da operadora ou agrupador"
                   v-focus
            >
          </div>
        </div>
      </div>
      <table class="table table-hover" v-else>
        <thead>
        <tr>
          <th>#</th>
          <th>Nome</th>
          <th class="text-right"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in insurances" :key="i">
          <td>{{ i + 1  }}</td>
          <td>{{ item.name }}</td>
          <td class="text-right">
            <button class="btn btn-error btn-icon btn-action btn-sm"
                    :class="{loading: deleting && idx === i}"
                    :disabled="deleting"
                    @click="remove(item.id, i)">
              <fa-icon :icon="['fal', 'times']" />
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:footer>
      <button class="btn btn-primary mr-1"
              v-if="newItem"
              :disabled="saving"
              :class="{loading: saving}"
              @click="save">
        Salvar
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/form';
import { capitalize } from '@/filters/capitalize';
import {
  CREATE_INSURANCE,
  DELETE_INSURANCE,
} from '@/data/actions/modules/general';

export default {
  mixins: [formMixin],
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idx: null,
      loading: false,
      saving: false,
      deleting: false,
      newItem: false,
      insurances: [],
      form: {
        id: '',
        name: '',
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    canCreateAccess() {
      return this.$can(CREATE_INSURANCE);
    },
    canRemoveAccess() {
      return this.$can(DELETE_INSURANCE);
    },
  },
  validations() {
    return {
      form: {
        name: { required },
      },
    };
  },
  methods: {
    async init() {
      this.newItem = this.isNew;
      this.load();
    },
    load() {
      const params = {
        active: true,
        limit: 0,
      };

      this.loading = true;

      return this.$http.get('/insurances', { params })
        .then(({ data }) => {
          this.insurances = data.items;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
    addNew() {
      if (!this.canCreateAccess) {
        this.$toast.error('Acesso não autorizado!');
        return;
      }
      this.newItem = true;
      this.form.id = '';
      this.form.name = '';
    },
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return null;
      }

      const found = this.insurances
        .find(item => capitalize(item.name) === capitalize(this.form.name));

      if (found) {
        this.$toast.error('Já existe um cadastro com este nome!');
        return null;
      }

      this.saving = true;

      return this.$http.post('/insurances', this.clone(this.form))
        .then(({ data }) => {
          this.$toast.success('Operadora cadastrada com sucesso!');
          this.$emit('save', data);
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
    remove(id, i) {
      if (!this.canRemoveAccess) {
        this.$toast.error('Acesso não autorizado!');
        return;
      }

      if (this.deleting) {
        return;
      }

      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente remover este registro?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.deleting = true;
              this.idx = i;
              close();
              this.$http
                .delete(`/insurances/${id}`)
                .then(() => {
                  this.insurances.splice(i, 1);
                  this.$emit('remove', id);
                })
                .catch(() => {
                  this.$toast.error('Ocorreu um erro. Tente novamente!');
                })
                .finally(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
  },
};
</script>
